import { render, staticRenderFns } from "./ChangePasswordBanner.vue?vue&type=template&id=ad222486&"
import script from "./ChangePasswordBanner.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports